module.exports = __webpack_public_path__ + "img/bakkers voor winkel.61cdd519.jpg";